export default {
  newsStates: {
    1: 'type-news',
    33: 'type-news',
    32: 'type-unusal',
    31: 'type-news',
    28: 'type-level',
    27: 'type-summary',
    34: 'type-event',
  },
  newsImgTypes: {},
};
